if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          {this.submitButton.setAttribute('aria-haspopup', 'dialog');}

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        // Submit form via hidden iframe to bypass Shopify's shop_events_listener
        // fetch wrapper (causes ERR_INTERNET_DISCONNECTED) and avoid sendBeacon
        // (blocked by tracker blockers as ERR_BLOCKED_BY_CLIENT).
        const frame = document.createElement('iframe');
        frame.name = 'cart-add-' + Date.now();
        frame.style.display = 'none';
        document.body.appendChild(frame);

        const originalTarget = this.form.target;
        this.form.target = frame.name;

        frame.addEventListener('load', () => {
          // Skip the initial about:blank load
          try {
            if (frame.contentWindow.location.href === 'about:blank') return;
          } catch (_e) {
            // Cross-origin means navigation happened — item was added
          }

          // Restore form target
          this.form.target = originalTarget || '';

          if (!this.cart) {
            document.body.removeChild(frame);
            window.location = window.routes.cart_url;
            return;
          }

          // Fetch updated cart sections using unwrapped fetch (defined in theme.liquid)
          const sectionIds = this.cart
            .getSectionsToRender()
            .map((s) => s.id)
            .join(',');
          const url = `${window.location.origin}${window.location.pathname}?sections=${sectionIds}`;
          (window._cleanFetch || fetch)(url)
            .then((r) => r.json())
            .then((sections) => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: sections,
              });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents({ sections });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents({ sections });
              }
            })
            .catch((e) => {
              console.error('Cart sections fetch error:', e);
            })
            .finally(() => {
              document.body.removeChild(frame);
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty'))
                {this.cart.classList.remove('is-empty');}
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
        });

        // Submit the form into the hidden iframe (native POST, bypasses all JS wrappers)
        this.form.submit();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
